webpackJsonp([213534597649335],{

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(18);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Sidebar = __webpack_require__(19);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _stylelab_resume_edited = __webpack_require__(666);
	
	var _stylelab_resume_edited2 = _interopRequireDefault(_stylelab_resume_edited);
	
	var _shangYu_resume_ = __webpack_require__(342);
	
	var _shangYu_resume_2 = _interopRequireDefault(_shangYu_resume_);
	
	__webpack_require__(560);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Post from '../components/Post';
	
	// import testPic from './japan.png';
	
	
	var IndexRoute = function (_React$Component) {
	  _inherits(IndexRoute, _React$Component);
	
	  function IndexRoute() {
	    _classCallCheck(this, IndexRoute);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  IndexRoute.prototype.render = function render() {
	    var items = [];
	    var _props$data$site$site = this.props.data.site.siteMetadata,
	        title = _props$data$site$site.title,
	        subtitle = _props$data$site$site.subtitle;
	    /*
	    const posts = this.props.data.allMarkdownRemark.edges;
	    
	    posts.forEach((post) => {
	      items.push(<Post data={post} key={post.node.fields.slug} />);
	    });
	                 <Link to="/">
	                  <img src={testPic} style={{ maxHeight: "30%" }} /> 
	                </Link>
	     return (
	      <div>
	        <Helmet>
	          <title>{title}</title>
	          <meta name="description" content={subtitle} />
	        </Helmet>
	        <Sidebar {...this.props} />
	        <div className="content">
	          <div className="content__inner">
	            {items}
	          </div>
	        </div>
	      </div>
	    );
	    */
	
	    // const cvLink = "https://drive.google.com/open?id=1txJy3CpGJBuSMqwHNsUS8TXjU_KvZOi9";
	
	    var vivianLink = "https://www.csie.ntu.edu.tw/~yvchen/index.html";
	    var googleFellowshipBlog = "https://ai.googleblog.com/2020/10/announcing-2020-google-phd-fellows.html?utm_source=feedburner&utm_medium=feed&utm_campaign=Feed:+blogspot/gJZg+(Google+AI+Blog)&m=1";
	    var foxconnTechAward = "https://www.facebook.com/story.php?story_fbid=1316062665500089&id=313637069075992";
	    var bestThesisAward = "https://www.aclclp.org.tw/grants_c.php";
	    var taaiThesisAward = "http://www.taai.org.tw/content/636c6f6843baf300176b43ce";
	    var rit = "https://rit.rakuten.com/";
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          title
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: subtitle })
	      ),
	      _react2.default.createElement(_Sidebar2.default, this.props),
	      _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'content__inner' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'content__news__title' },
	            'News:'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              '(10/18/2022) Received ',
	              _react2.default.createElement(
	                'a',
	                { href: bestThesisAward, target: '_blank' },
	                '2022 ACLCLP Best Thesis Award'
	              ),
	              '.'
	            )
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              '(11/11/2022) Received ',
	              _react2.default.createElement(
	                'a',
	                { href: taaiThesisAward, target: '_blank' },
	                '2022 TAAI PhD Thesis Award (Honorable Mention)'
	              ),
	              '.'
	            )
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              '(2/1/2023) Joined Rakuten Institute of Technology as a Research Scientist.'
	            )
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { className: 'content__intro' },
	            _react2.default.createElement(
	              'div',
	              { className: 'content__intro__text' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'Research Scientist at ',
	                _react2.default.createElement(
	                  'a',
	                  { href: rit, target: '_blank' },
	                  'Rakuten Institute of Technology'
	                ),
	                '.',
	                _react2.default.createElement('br', null),
	                'I am Shang-Yu Su (\u8607\u4E0A\u80B2), my research interests cover Natural Language Processing with Deep Learning, Dialogue Systems, and Search/Recommendation Systems.',
	                _react2.default.createElement('br', null),
	                'I obtained my Ph.D. in Computer Science from National Taiwan University (NTU), where I was fortunate to be advised by Prof. ',
	                _react2.default.createElement(
	                  'a',
	                  { href: vivianLink, target: '_blank' },
	                  'Yun-Nung (Vivian) Chen. '
	                ),
	                'I received B.S. degree from the department of Electrical Engineering.',
	                _react2.default.createElement('br', null),
	                'My research was supported by  ',
	                _react2.default.createElement(
	                  'a',
	                  { href: googleFellowshipBlog, target: '_blank' },
	                  'Google PhD Fellowship'
	                ),
	                '. Previously, I was a research intern at Google Research, Amazon (Alexa AI), and  Microsoft.',
	                _react2.default.createElement('br', null),
	                'For more details, check out my full ',
	                _react2.default.createElement(
	                  'a',
	                  { href: _shangYu_resume_2.default, target: '_blank' },
	                  'CV/resume '
	                ),
	                'and also feel free to contact me via email: ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'mailto:shangyusu.tw@gmail.com' },
	                  'shangyusu.tw@gmail.com.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'content__intro__picture' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/' },
	                _react2.default.createElement('img', { src: _stylelab_resume_edited2.default, style: { maxHeight: "100%" } })
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return IndexRoute;
	}(_react2.default.Component);
	
	exports.default = IndexRoute;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 560:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/shang-yu_resume_20241228.e307c908.pdf";

/***/ }),

/***/ 666:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stylelab_resume_edited.ac913eb6.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-1a2de1896f5485ad964b.js